import React from 'react'

import withPlayerApi from '../../hocs/withPlayerApi'
import cookies from '../../utils/cookies'
import {
  STV_COOKIES,
  EU_REGION_CODE,
  DEFAULT_GROUPTOKEN,
} from '../../constants'
import PageError from './PageError'
import { groupFromResults } from '../../utils/remapPromotedGroupAssets'

const PageErrorContainer = props => <PageError {...props} />

const apiParams = ({ order, groupToken }) => ({
  limit: 8,
  orderBy: order,
  groupToken,
})

PageErrorContainer.getInitialProps = async ({ playerApi, req, query }) => {
  const { STV_GROUPTOKEN } = STV_COOKIES
  let groupToken = cookies.get(STV_GROUPTOKEN, req)
  // does the user have no grouptoken, or an EU region grouptoken, (0081 or 0080)?
  if (!groupToken || groupToken[2] === EU_REGION_CODE) {
    // we don't have content to show EU users on the homepage, so just use a default grouptoken
    groupToken = DEFAULT_GROUPTOKEN
  }
  const hostname = req?.headers.host.split(':')[0] || window.location.hostname

  const results = await playerApi({
    path: '/episodes',
    query: apiParams({ order: '-views', groupToken, limit: 12 }),
  })

  const mostPopular = groupFromResults({ promotedGroup: results, hostname, results })
  const slug = query?.slug

  return {
    mostPopular,
    groupToken,
    slug,
  }
}

export default withPlayerApi(PageErrorContainer)
